import React from 'react';

import { Button } from '@chakra-primitives/button';

import styles from './ErrorSplashScreen.module.less';
import MarleyIcon from '../icons/MarleyIcon';

const ErrorSplashScreen = () => {
  const handleClickBackToHome = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    window.location.href = '/';
  };

  return (
    <div className={styles['splash-screen']}>
      <div className={styles.logo}><MarleyIcon /></div>
      <div className={styles.body}>
        <div className={`${styles.message} ${styles.error}`}>
          Unexpected Error - Please contact support@himarley.com
        </div>
        <Button data-testid="back-to-home" onClick={handleClickBackToHome}>Back to Home</Button>
      </div>
    </div>
  );
};

export default ErrorSplashScreen;
